import React from 'react';
import { quadrantInfo, quadrantOrder } from './quadrantInfo';
import { selectedItemStyle } from './componentStyles';

const QuadrantSelector = ({ selectedQuadrant, onQuadrantChange }) => {
  return (
    <div className="grid grid-cols-2 gap-1 max-w-[200px]">
      {quadrantOrder.map((key) => (
        <button
          key={key}
          className={`flex flex-col items-center justify-center p-1.5 rounded text-center ${
            selectedQuadrant === key ? selectedItemStyle : 'ring-1 ring-gray-200 bg-gray-50'
          }`}
          onClick={() => onQuadrantChange(key)}
        >
          <span className="mb-0.5">{quadrantInfo[key].icon.small}</span>
          <span className="text-xs font-medium leading-tight">{quadrantInfo[key].label}</span>
        </button>
      ))}
    </div>
  );
};

export default QuadrantSelector;